import React, {useState} from 'react'
import './portfolio.css'
import { PortfolioData } from './PortfolioData'
import {useHistory} from 'react-router-dom'
import IMG1 from '../../assets/portfolio1.jpg'
import IMG2 from '../../assets/portfolio2.jpg'
import IMG3 from '../../assets/portfolio3.jpg'
import IMG4 from '../../assets/portfolio4.jpg'
import IMG5 from '../../assets/portfolio5.png'
import IMG6 from '../../assets/portfolio6.jpg'

const Portfolio = () => {
  return (

    <section id='projects' >
      <h5>My Recent Work</h5>
      <h2>Projects</h2>

      <div className='container portfolio__container'>
      {PortfolioData.map((item,index)=>{
          return(
            
            <article className='portfolio__item'>
          <div className='portfolio__item-image'>
            {item.img}
            <h3>{item.title}</h3>
            <div className='portfolio__item-cta'>
              <a href={item.link1} className='btn'>More Info</a>
              <a href={item.link2} target='_blank' className='btn'>GitHub</a>
            </div>
          </div>
        </article>

          )})}

        
      </div>
    </section>
  )
}



export default Portfolio